import { useState } from 'react';

import { useGoogleToken } from 'api/google/useGoogleToken';

import { useScreenMessage } from '@gogame/screens';

import { revoke } from '../../sources';

export const useGoogleAuth = ({
  signInOnLoad,
  onNoSession,
  setCurrentProvider,
}) => {
  const { showErrorMessage } = useScreenMessage('googleAuth');
  const [credential, setCredential] = useState(null);

  const { loaded, isAuthenticated, signOut } = useGoogleToken({
    loginOnLoad: signInOnLoad,
    onNoSession: onNoSession,
    setCurrentProvider: setCurrentProvider,
    onSuccess: ({ credential }) => {
      setCredential(credential);
    },
    onError: (e) => {
      showErrorMessage(e?.message);
    },
  });

  return {
    _hasError: false,
    _name: 'google',
    loaded: loaded,
    logout: async () => {
      try {
        await revoke();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        signOut();
      }
    },
    getAccessToken: async () => {
      return credential;
    },
    active: false,
    isAuthenticated,
    onUnauthorized: async () => {
      if (isAuthenticated) {
        signOut();
      }
    },
  };
};
